import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';

/* Layout */
import Layout from '@/layout';
// 注册一个全局前置路由守卫后
// 在vue-router在3.1.0版本之后，push和replace方法会返回一个promise对象，如果跳转到相同的路由，就报promise uncaught异常
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   当设置 true 的时候该路由不会在侧边栏出现
 * alwaysShow: true               当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect           当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'             设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * meta : {
    roles: ['admin','editor']    设置该路由进入的权限，支持多个权限叠加
    title: 'title'               设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'/'el-icon-x' 设置该路由的图标，支持 svg-class，也支持 el-icon-x element-ui 的 icon
    noCache: true                如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    affix: true                   如果设置为true，它则会固定在tags-view中(默认 false)
    breadcrumb: false            如果设置为false，则不会在breadcrumb面包屑中显示(默认 true)
    activeMenu: '/example/list'  当路由设置了该属性，则会高亮相对应的侧边栏。
                                 这在某些场景非常有用，比如：一个文章的列表页路由为：/article/list
                                 点击文章进入文章详情页，这时候路由为/article/1，但你想在侧边栏高亮文章列表的路由，就可以进行如下设置
  }
 */
/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: `/redirect`,
    component: Layout,
    hidden: true,
    children: [
      {
        path: `/redirect/:path(.*)`,
        component: () => import('@/views/redirect/index'),
      },
    ],
  },
  {
    path: `/login`,
    component: () => import('@/views/login/index'),
    hidden: true,
  },
  {
    path: `/register`,
    component: () => import('@/views/login/register'),
    hidden: true,
  },
  {
    path: `/transfer`,
    component: () => import('@/views/login/transfer'),
    hidden: true,
  },
  {
    path: `/auth-redirect`,
    component: () => import('@/views/login/auth-redirect'),
    hidden: true,
  },
  {
    path: `/404`,
    component: () => import('@/views/error-page/404'),
    hidden: true,
  },
  {
    path: `/401`,
    component: () => import('@/views/error-page/401'),
    hidden: true,
  },
  {
    path: `/img`,
    component: () => import('@/views/index/image'),
    hidden: true,
  },

  {
    path: `/`,
    component: Layout,
    redirect: `/index`,
    children: [
      {
        path: 'index',
        component: () => import('@/views/index/index'),
        name: 'home',
        noCache: true,
        meta: { title: '首页', icon: 'yzs_home', affix: true },
      },
    ],
  },
  {
    // 隐私政策
    path: `/onestop/deal`,
    name: 'Deal',
    hidden: true,
    component: () => import('@/views/login/text/deal.vue'),
    meta: {
      hideNfHead: true,
      keepAlive: false,
      hasMenu: false,
    },
  },
  {
    // 用户协议
    path: `/onestop/policy`,
    name: 'Policy',
    hidden: true,
    component: () => import('@/views/login/text/policy.vue'),
    meta: {
      hideNfHead: true,
      keepAlive: false,
      hasMenu: false,
    },
  },
  //   {
  //     // 签署合同
  //     path: `/onestop/public/contract`,
  //     name: 'Contract',
  //     hidden: true,
  //     component: () => import('@/views/publicPages/Contract'),
  //     meta: {
  //       hideNfHead: true,
  //       keepAlive: false,
  //       hasMenu: false,
  //     },
  //   },
];

// 循环modules 自动注册路由
const modulesFiles = require.context('./modules', true, /\.js$/);
const modulesRoutes = modulesFiles
  .keys()
  .reduce((modules, modulePath) => {
    const value = modulesFiles(modulePath);
    modules.push(value.default);
    return modules;
  }, [])
  .sort((a, b) => {
    return a.meta.id - b.meta.id;
  });
export const asyncRoutes = [
  // 404 page must be placed at the end !!!
  // plateRouter,
  ...modulesRoutes,
  {
    path: `/*`,
    redirect: `/404`,
    hidden: true,
  },
];

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

router.beforeEach(async (to, from, next) => {
  Vue.prototype.$bus.$emit('routeFrom', from);
  // 动态渲染菜单
  store.commit('updateMenu', [
    {
      path: '/',
      meta: {
        id: 1,
        title: '首页',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE', 'NORMAL', 'NORMAL_ZY'],
      },
      children: [],
    },
    ...modulesRoutes,
  ]);
  // 获取最新的消息通知
  store.dispatch('settings/getNotify');
  next();
});

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
